<!-- 学研汇首页 -->
<template>
  <div class="home">
    <Topbar></Topbar>
    <div class="navbar">
      <div class="c">
        <!-- logo图片 -->
        <!-- <div class="logo" @click="$router.push('/')">
          <img :src="`${baseUrl}/static/defaults/logo.png`" alt="" />
        </div> -->
        <logoBox />
        <!-- 搜索框 -->
        <div class="search_box">
          <el-autocomplete v-model="searchText" :popper-append-to-body="false" :fetch-suggestions="getSearchList"
            placeholder="请输入仪器名称或型号" @select="clickSearchItem" value-key="name" value="id" :trigger-on-focus="false">
            <img slot="prefix" src="../assets/imgs/search.png" alt="" />
            <el-button class="search_btn" slot="append" @click="toSearchResult">搜索</el-button>
          </el-autocomplete>
        </div>
        <!-- 预存按钮 -->
        <div class="demand_btn" @click="$router.push('/deposit')">
          <div class="liwu_box">
            <img src="@/assets/image/home/liwu.png" alt="" />
            <span>预存有礼</span>
          </div>
        </div>

        <el-dropdown style="cursor: pointer" placement="bottom" v-if="userInfo && JSON.stringify(userInfo) != '{}'"
          @command="handleCommand">
          <span class="el-dropdown-link">
            {{ userInfo.nickname
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="myCenter">个人中心</el-dropdown-item>
            <el-dropdown-item command="myInvoice">我的发票</el-dropdown-item>
            <el-dropdown-item command="memberCenter">会员中心</el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div v-else class="login_btn">
          <span @click="toLogin">登录</span>/<span @click="toRegister">注册</span>
        </div>
        <!-- 站内信图标 -->
        <message-box v-if="false"></message-box>
      </div>
    </div>
    <div class="tabBar">
      <div class="tabBar_header">
        <div class="c">
          <div class="tabBar_item" :class="{
            activeItem:
              $route.path.includes(item.path) ||
              $route.path.includes(item.path2),
            show_drawer: item.compsName == 'category',
          }" v-for="(item, index) in viewList" :key="index" @click="switchTab(item)" @mouseover="tabMouseover(item)">
            <span class="name_pre">
              {{ item.name }}
              <div v-if="getName(item.name)" :style="{ backgroundColor: getColor(item.name) }" class="right_box">
                {{ getName(item.name) }}
              </div>
            </span>
          </div>
        </div>
        <!-- 抽屉 -->
        <div class="drawer" :class="{ show_drawer: showDrawer }" @mouseover="drawerMouseover" @mouseout="mouseout">
          <div class="content c" :style="{ justifyContent: flexEnd ? 'flex-end' : 'flex-start' }">
            <div class="list">
              <div class="list_item" v-for="item in drawerData" :key="item.id">
                <div class="left">
                  <div class="parent_node">
                    <img :src="bandaotiIcon" alt="" v-if="item.id == '10067'"
                      :style="{ width: '25px', height: '25px', marginRight: '5px' }">
                    <img :src="xyhtIcon" alt="" v-if="item.icon == 'xyht'"
                      :style="{ width: '20px', height: '20px', marginRight: '5px' }">
                    <i v-else :class="[
                      'iconfont',
                      item.icon && item.icon.replace('#', ''),
                    ]"></i>
                    {{ item.name }}
                  </div>
                </div>
                <div class="right">
                  <div class="tag_item" v-for="(i, ix) in item.children" :key="ix" @click="toPath(i)">
                    {{ i.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 只是为了占位,避免鼠标一不小心滑出去 抽屉消失 -->
          <div :style="{ height: '400px', background: 'transparent' }" v-show="showDrawer"></div>
        </div>
      </div>

      <!-- tabs的内容 -->
      <router-view></router-view>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
    <!-- 右边悬浮栏 -->
    <RightBar></RightBar>
    <!-- <div class="mask" v-if="showDrawer" @click="showDrawer = false"></div> -->

    <elementsPeriodicTable v-if="false" :multiple="true" @choiceEle="choiceEle"></elementsPeriodicTable>
  </div>
</template>

<script>
import Topbar from '@/components/Topbar.vue'
import Footer from '@/components/Footer.vue'
import RightBar from '@/components/RightBar.vue'
import elementsPeriodicTable from '@/components/elementsPeriodicTable'
// import { localStorage } from "@/tool/storage";
import { mapState, mapActions, mapMutations } from 'vuex'
import { getAllCategory, searchKeyword, getWebTag, getTestGoodsList } from '@/api/goods'
import MessageBox from '@/components/messageBox.vue'
import bandaotiIcon from '@/assets/icons/bandaoti.svg'
import xyhtIcon from '@/assets/icons/xyht.png'
export default {
  name: 'HomeView',
  components: {
    Topbar,
    Footer,
    RightBar,
    MessageBox,
    elementsPeriodicTable,
  },
  data() {
    return {
      bandaotiIcon: bandaotiIcon,
      xyhtIcon: xyhtIcon,
      searchText: '',
      activeView: 'homeView',
      showDrawer: false,
      flexEnd: false,
      viewList: [
        {
          name: '首页',
          compsName: 'homeView',
          path: '/home',
          showDrawer: false,
        },
        {
          name: '测试分类',
          compsName: 'category',
          path: '/category',
          showDrawer: true,
        },

        {
          name: '同步辐射',
          compsName: 'syncRdiation',
          path: '/syncRdiation',
          showDrawer: true,
          query: { categoryId: process.env.VUE_APP_MODE === 'production' ? '10048' : '10025' },
        },
        {
          name: '高端测试',
          compsName: 'acTem',
          path: '/acTem',
          showDrawer: true,
          query: { categoryId: process.env.VUE_APP_MODE === 'production' ? '10049' : '10018' },
        },
        {
          name: '原位测试',
          compsName: 'situTest',
          path: '/situTest',
          showDrawer: true,
          query: { categoryId: process.env.VUE_APP_MODE === 'production' ? '10050' : '10040' },
        },
        {
          name: '半导体',
          compsName: 'semiconductor',
          path: '/semiconductor',
          showDrawer: true,
          query: { categoryId: process.env.VUE_APP_MODE === 'production' ? '10088' : '10067' },
        },
         {
          name: '计算硬件',
          compsName: 'computingHardware',
          path: '/computingHardware',
        },
        {
          name: '纳米材料',
          compsName: 'nmMaterial',
          path: '/nmMaterial',
          showDrawer: false,
        },
        {
          name: '学研计算',
          compsName: 'cptSimulation',
          path2: '/cptGoodsView',
          path: '/cptSimulation',
          showDrawer: false,
        },
        {
          name: '学研绘图',
          compsName: 'scientificGraphing',
          path: '/scientificGraphing',
          showDrawer: true,
          drawerData: [
            {
              name: "学研绘图",
              icon: "xyht",
              children: [
                {
                  name: "期刊封面",
                  path: '/scientificGraphing',
                  id: 365
                },
                {
                  name: "三维插图",
                  path: '/scientificGraphing',
                  id: 361
                },
                {
                  name: "手绘插图",
                  path: '/scientificGraphing',
                  id: 363
                },
                {
                  name: "动画制作",
                  path: '/scientificGraphing',
                  id: 372
                },
                {
                  name: "PPT设计",
                  path: '/scientificGraphing',
                  id: 373
                }
              ]
            }
          ]
        },
        {
          name: '论文润色',
          compsName: 'polishingThesis',
          path: '/polishingThesis',
          showDrawer: false,
        },
        {
          name: ' 智识引擎',
          compsName: 'intellectualEngine',
          showDrawer: true,
          drawerData: [
            {
              name: "智识引擎",
              icon: "#icon-shujufenxi",
              children: [
                {
                  name: "数据解析",
                  path: '/dataAnalysis',
                },
                {
                  name: "学研云课堂",
                  path: '/classroom'
                }
              ]
            }
          ]
        }
        // ,
        // {
        //   name: '数据解析',
        //   compsName: 'dataAnalysis',
        //   path: '/dataAnalysis',
        //   showDrawer: false,
        // },
        // {
        //   name: '学研云课堂',
        //   compsName: 'classroomView',
        //   path: '/classroom',
        //   showDrawer: false,
        // },
      ],
      drawerData: [],
      drawerDataAll: [],
      drawerActive: 1,
      bannerList: [],
      tagList: [],
      goodsList: []
    }
  },
  created() {
    this.activeView = this.$route.path
    this.getAllCategory()
    this.getWebTagList()
    this.getGoodsList()
  },
  computed: {
    ...mapState('user', ['userInfo']),
    activeDrawerData() {
      return this.drawerData[this.drawerActive - 1]
    },
  },
  methods: {
    getGoodsList() {
      getTestGoodsList({ 'categoryId': this.mainCategoryId }).then(res => {
        this.goodsList = res
      })
    },
    getFirstGoodsId(categoryId) {
      let goods = this.goodsList.find(obj => obj.categoryId === categoryId)
      return goods ? goods.id : goods;
    },
    // 点击下拉列表
    handleCommand(command) {
      // 退出登录
      if (command == 'logout') {
        this.$confirm('确定要退出登录吗？', '提示').then(() => {
          this.logout().then(() => {
            this.$message({ type: 'success', message: '退出登录成功' })
            this.clearUserInfo({}) // 更新vuex
            this.$router.push('/Login')
          })
        })
      } else if (command == 'myCenter') {
        this.$router.push('/myCenter/centerHome')
      } else if (command == 'myInvoice') {
        this.$router.push('/myCenter/invoiceInfoAdmin')
      } else if (command == 'memberCenter') {
        const { role } = this.userInfo
        if (role && role.includes('BUYER_VIP')) {
          // 是会员 去会员中心页面
          this.$router.push('/memberCenter')
        } else {
          // 不是会员  去了解会员页面
          this.$router.push('/understandMember')
        }
      }
    },
    // 跳转登录页面
    toLogin() {
      this.$router.push('/Login')
    },
    // 跳转注册页面
    toRegister() {
      this.$router.push('/Register?type=0')
    },
    getWebTagList() {
      getWebTag().then((res) => {
        this.tagList = res
      })
    },
    getName(val) {
      const item = this.tagList.find((item) => item.module === val)
      return item ? item.tag : null
    },
    getColor(val) {
      const item = this.tagList.find((item) => item.module === val)
      return item ? item.color : null
    },
    ...mapActions('user', ['logout']),
    ...mapMutations('user', ['clearUserInfo']),
    // 跳转搜索结果页面
    toSearchResult() {
      if (!this.searchText) {
        // this.searchText = "";
        return
      }
      let path = `/searchResult?keyword=${this.searchText}`
      this.$router.push(path)
      this.$EventBus.$emit('search', this.searchText)
    },
    // 获取搜索列表
    getSearchList(searchStr, callBack) {
      if (!searchStr) {
        callBack([])
      } else {
        searchKeyword({ keyword: searchStr }).then((res) => {
          callBack(res)
        })
      }
    },
    clickSearchItem(item) {
      if (item.id) {
        this.$router.push(`/details/${item.id}`)
      }
    },

    // 获取分类的数据
    getAllCategory() {
      getAllCategory().then((res) => {
        this.drawerDataAll = res
        this.drawerData = res

      })
    },

    // 切换tba
    switchTab(item) {
      this.activeView = item.path
      this.showDrawer = false
      // this.$router.push(item.path)
      this.$router.push({ path: item.path, query: item.query })

    },
    // 点击抽屉的子项 跳转页面
    toPath(item) {

      if (item.path) {
        let path = `${item.path}?id=${item.id}`
        this.$router.push(path)
      } else {
        console.log('item//', item);
        // 点击半导体 子分类跳转分类
        if (item.compsName === 'semiconductor') {
          this.$router.push(`/semiconductor?categoryId=${item.id}`)
        } else if (item.compsName === 'acTem' || item.compsName === 'syncRdiation' || item.compsName === 'situTest') {
          let goodsId = this.getFirstGoodsId(item.id);
          if (goodsId) {
            this.$router.push(`/${item.compsName}?categoryId=${item.parentId}&goodsId=${goodsId}`)
          } else {
            this.$router.push(`/${item.compsName}?categoryId=${item.parentId}`)
          }
        } else {
          this.$router.push(`/category?id=${item.id}`)
        }
      }

    },
    // 切换抽屉左侧list
    changeActive(value) {
      // this.parentNode = item;
      this.drawerActive = value
    },
    // 抽屉移入事件
    drawerMouseover() {
      this.showDrawer = true
    },
    // tab-item移入事件
    tabMouseover(item) {
      console.log('item', item);

      // 如果滑动到智能引擎,将抽屉内容放到右边去
      this.flexEnd = item.compsName === 'intellectualEngine'
      if (!this.$route.path.includes('category')) {
        this.showDrawer = item.showDrawer
        if (item.query) {
          this.drawerData = this.drawerDataAll.filter(f => f.id === item.query.categoryId);
        } else if (item.drawerData) {
          this.drawerData = item.drawerData
        } else {
          this.drawerData = this.drawerDataAll
        }
        this.drawerData.forEach(f => {
          f.children.forEach(f => {
            f.compsName = item.compsName
          })
        })

      }
    },
    // tab-item移出事件
    mouseout() {
      this.showDrawer = false
    },
    // 元素周期表选择事件
    choiceEle(value) {
      console.log(value)
    },
  },
}
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;

  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 300px;
    left: 0;
    right: 0;
    background: rgba(95, 95, 95, 0.38);
    z-index: 9;
  }

  .navbar {
    width: 100%;
    display: flex;
    margin: 0 auto;
    height: 80px;
    align-items: center;
    z-index: 999;
    background-color: #fff;

    .c {
      display: flex;
      align-items: center;
      justify-content: space-between;
      // align-items: end;
    }

    .logo {
      cursor: pointer;

      img {
        max-width: 200px;
      }
    }

    .search_box {
      // width: 368px;
      height: 40px;
      margin: 0 0px 0 395px;

      img {
        width: 20px;
        height: 20px;
      }

      .search_btn {
        font-size: 16px;
        color: white;
        height: 40px;
        vertical-align: middle;
        display: flex;
        align-items: center;
        justify-content: center;
        border-left: 0;
        background-color: @main-color;
        font-weight: 700;
        background: #056de8;
        border-radius: 0px 10px 10px 0px;
        font-size: 14px;
        color: #ffffff;
      }

      /deep/.el-input {
        width: 268px;
        font-size: 16px;
        height: 40px;

        .el-input__inner {
          width: 268px;
          border-radius: 10px 0px 0px 10px !important;
          border: 1px solid #056de8 !important;
          height: 40px;
          vertical-align: middle;
          font-size: 14px !important;
          font-weight: 550;
          padding-left: 32px;
        }

        .el-input__prefix {
          display: flex;
          align-items: center;
          left: 10px;
        }
      }
    }

    .demand_btn {
      cursor: pointer;

      .liwu_box {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #ffffff;
        width: 114px;
        height: 40px;
        background: #ff414b;
        border-radius: 10px 10px 10px 10px;

        img {
          height: 24px;
          width: 24px;
          vertical-align: middle;
          margin-right: 5px;
        }
      }

      // img {
      //   vertical-align: middle;
      // }
    }

    .login_btn {
      display: flex;
      justify-content: space-between;
      text-align: center;
      line-height: 40px;
      width: 98px;
      height: 40px;
      font-size: 14px;
      color: #ffffff;
      font-style: normal;
      background: #056de8;
      border-radius: 10px 10px 10px 10px;

      span {
        display: flex;
        justify-content: center;
        height: 100%;
        width: 49%;
        cursor: pointer;
      }
    }
  }

  .tabBar {
    display: flex;
    flex-direction: column;
    background-color: #f8f8f8;

    .tabBar_header {
      min-width: 1200px;
      height: 56px;
      box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.05);
      // border-top: 1px solid #e4e4e8;
      display: flex;
      align-items: center;
      justify-content: space-around;
      position: sticky;
      top: 0;
      z-index: 999;
      background-color: #fff;

      box-shadow: 0px 4px 7px 0px rgba(178, 178, 178, 0.25);

      .c {
        display: flex;
        align-items: center;
      }

      .drawer {
        width: 100%;
        position: absolute;
        top: 55px;
        // background-color: #fff;
        font-size: 16px;

        .content {
          height: 0;
          transition: all 0.1s linear;
          display: flex;


          .list {
            display: none;
            transition: all 0.1s linear;

            .list_item {
              display: flex;
              background-color: #fff;
              width: 100%;
              height: auto;
              align-items: stretch;

              .left {
                width: 150px;

                padding: 0 10px;

                .parent_node {
                  text-align: center;
                  min-height: 56px;
                  border-bottom: 2px solid @main-color;
                  height: 100%;
                  display: flex;
                  padding-left: 18px;
                  align-items: center;

                  .iconfont {
                    color: @main-color;
                    font-size: 22px;
                    margin-right: 5px;
                  }

                  &:hover {
                    color: @main-color;
                  }
                }
              }

              .right {
                flex: 1;
                display: flex;
                flex-wrap: wrap;
                padding-left: 40px;
                min-height: 56px;
                align-items: center;
                background-color: #f0f7ff;
                border-bottom: 4px solid #fff;

                .tag_item {
                  margin: 9px 60px 9px 0;
                  //min-width: 100px;
                  width: 180px;
                  float: left;
                  text-align: left;
                  cursor: pointer;
                }

                .tag_item:hover {
                  color: @main-color;
                }
              }
            }

            .list_item:last-child {
              .left {
                .parent_node {
                  border-bottom: 0;
                }
              }
            }
          }
        }
      }

      .show_drawer {
        .content {
          // min-height: 282px;
          height: auto;

          .list,
          .tag_content {
            display: block;
          }
        }
      }
    }

    .tabBar_item {
      position: relative;
      flex: 1;
      cursor: pointer;
      height: 100%;
      line-height: 56px;
      font-size: 18px;
      color: #2f2f2f;
      font-weight: 700;
      transition: all 0.5s;
      background-color: #fff;
      text-align: center;

      &:hover {
        color: @main-color;
      }
    }

    .name_pre {
      display: flex;
      justify-content: center;
      position: relative;
      text-align: center;
    }

    .right_box {
      position: absolute;
      // left: 50%;
      // transform: translate(-50%, 0%);
      top: -5px;
      font-size: 12px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 12px;
      height: 20px;
      // background: #a244ef;
      border-radius: 6px 6px 6px 0px;
    }

    .activeItem {
      background-color: @main-color;
      color: #fff;

      &:hover {
        color: #fff;
      }
    }
  }
}

::v-deep .el-input-group__append {
  border-radius: none;
  border: 0px salmon;
}
</style>
